import { useGetDatasetMapperData } from "api/api-hooks/dataset-mapper-hooks";

export const useDatasetMappedValue = (
  mapValue: number | undefined,
  mapperId: number
): { value: string; isLoading: boolean } => {
  const { data, isLoading } = useGetDatasetMapperData(mapperId);

  if (isLoading) return { value: "", isLoading };
  if (mapValue === undefined) return { value: "N/A", isLoading };

  const mappedValue = data?.mappings?.[mapValue];
  return { value: String(mappedValue ?? mapValue), isLoading };
};
